import React, { useRef, useMemo, useCallback, useEffect, useState } from 'react'

import classnames from 'classnames'
import TextRender from '@/components/TextRender'
import { Button } from 'antd'
import useFakeId from '@/hooks/useFakeId'
import http from '@/utils/request'
import sleep from '@/utils/sleep'
import FadeOut from '@/components/FadeOut'

import useUserReducers from '@/store/user'
import useReducers from '@/store/demo/creation'
import styles from './CreationDemo.module.scss'

export default React.memo(function CreationDemo() {
  const [state, actions] = useReducers()
  const fakeId = useFakeId()
  const lastRef = useRef()
  const [loading, setLoading] = useState(false)
  const [userState] = useUserReducers()

  useEffect(() => {
    actions.getChatMessages(fakeId)
  },  [])

  const messages = useMemo(() => {
    return state.messages[fakeId] || []
  }, [state.messages])

  const demos = useMemo(() => {
    const all = ['太阳系的行星有哪些？', '请帮我写一封关于项目进度更新的报告', '请帮我写一封个人求职信', 'iOS系统和Android系统各有哪些优缺点?', '生成一份青椒肉丝的菜谱和做法']

    return all.map(item => {
      return {
        visible: !messages.some(msg => msg.content === item),
        content: item,
      }
    })
  }, [messages])

  const submit = useCallback(async (content) => {
    if (loading) {
      return
    }
    setLoading(true)
    const newMessages = [
      ...messages, {
      content: content,
      role: 'user',
      id: Math.random()
    }]

    actions.setMessages({
      [fakeId]: [...newMessages, {
        content: '正在回复...',
        role: 'assistant',
        id: Math.random(),
      }]
    })

    try {
      const res = await http.post('/api/demo/chat/creation/create', {
        userId: fakeId,
        content: content,
      })

      await sleep(2)

      let start = 0

      let text = ''

      const timer = setInterval(() => {
        text += res.slice(start, start + 1)

        const lastMessage = {
          content: text,
          role: 'assistant',
          id: Math.random()
        }

        start += 1

        actions.setMessages({
          [fakeId]: [...newMessages, lastMessage]
        })

        if (start >= res.length) {
          clearInterval(timer)
          setLoading(false)
        }
      }, 50)

    } catch(err) {
      setLoading(false)
      actions.setMessages({ [fakeId]: messages })
      if (err.response?.data.code === '1001') {
        topup()
      }
    }
  }, [messages, fakeId, loading])

  if (userState.userInfo) {
    return null
  }

  return (
    <div className={styles.container}>
      {
        demos.length > 0 &&
        <div className={styles.tip}>试试点击下述要求</div>
      }

      <div className={styles.btns}>
        {
          demos.map(demo => {
            return <FadeOut key={demo.content} visible={demo.visible}><Button htmlType="button" onClick={() => submit(demo.content)}>{demo.content}</Button></FadeOut>
          })
        }
      </div>

      <div className={styles.messages}>
        {
          messages.map((item, index) => {
            return (
              <div key={item.id} className={classnames(styles.item, styles[item.role])}>
                <TextRender text={item.content}/>
              </div>
            )
          })
        }
        <div ref={lastRef}></div>
      </div>
    </div>
  )
})
